export default {
  SET_REPORTS(state, reports) {
    state.reports = reports;
  }
};